import { getLink } from "../../../utils/utils";

import translator from "./translator";

const content = {
  esp: (
    `
      <h4 class="mb-3 bold text-center">Lokomotivo</h4>

      <div class="poem">
        <p class="poem-block mb-3">
          Lokomotivo ĉe la perono: <br/>
          Peza, grandega, kaj ŝvitas kaldrono <br/>
          Kun sibla sono.
        </p>
        
        
        <p class="mb-3 bold text-center">* * *</p>

        
        <p class="poem-block mb-3">
          Staras kaj snufas, spiras kaj blovas, <br/>
          Varmon el sia ventrego elŝovas: <br/>
          Buĥĥ – varmegege! <br/>
          Uĥĥ – varmegege! <br/>
          Puff – varmegege! <br/>
          Uff – varmegege! <br/>
          Apenaŭ spiras, pene jam snufas, <br/>
          Sed la hejtist’ karbon ŝutas kaj ŝutas.
        </p>
        
        
        <p class="mb-3 bold text-center">* * *</p>

        
        <p class="poem-block mb-3">
          Vagonojn kroĉis al si kun knalo: <br/>
          Pezajn, grandajn, el fer’ kaj ŝtalo. <br/>
          En ĉiu vagono plena tumulto: <br/>
          Jen multaj bovinoj, ĉevalojn multo, <br/>
          En tria vagon’ sidas dikuloj <br/>
          Kaj manĝas kolbasojn sen skrupuloj. <br/>
          Kvara vagon’ plena je bananoj,  <br/>
          En kvina staras ses fortepianoj, <br/>
          En sesa veturas kanon’ – ho, giganta! <br/>
          Sub ĉiu rad’ – la trab’ firmiganta.  <br/>
          En sepa – ŝrankoj, tabloj el kverko,  <br/>
          En oka – porkoj kaj porka sterko, <br/>
          En naŭa – urs’, elefant’, du alpakoj, <br/>
          En deka – kestoj, kofroj kaj pakoj. <br/>
          Da tiuj vagonoj – longa vico, <br/>
          Pri la enhavo – neniu indico. <br/>
          Se eĉ aperus mil atletoj <br/>
          Kaj ĉiu manĝus po mil kotletoj, <br/>
          Kaj ĉiuj kunuzus sian fortegon, <br/>
          Ne povus ja movi ĉi-ĉaregon! <br/>
          Fumo – sor! <br/>
          Pff – vapor’! <br/>
          Fajfo – blek’! <br/>
          Radoj – ek!
        </p>
        
        
        <p class="mb-3 bold text-center">* * *</p>

        
        <p class="poem-block mb-3">
          De eko - lante – testude – maleme <br/>
          Moviĝis la ogro laŭ reloj dormeme, <br/>
          Ekkaptis vagonojn kaj trenas kun peno, <br/>
          Turniĝas, turniĝas la radoj de l’ treno. <br/>
          Akcelas kuradon, moviĝas rapide, <br/>
          Bruegas kaj tondras, sin strebas senbride, <br/>
          Sed kien? Ĉu laŭen? <br/>
          Sed kien? – Antaŭen! <br/>
          Laŭ reloj, laŭ reloj <br/>
          Tra pontoj, tuneloj, <br/>
          Tra montoj, tra kampoj, arbaro, eben’ <br/>
          Kaj hastas, kaj hastas por ĝusta alven’, <br/>
          Tondradas ĝi takte kaj frapas kun klak’: <br/>
          Tak-to-to, tak-to-to, tak-to-to, tak-tak! <br/>
          Facile, leĝere sin rulas al for’ <br/>
          Kvazaŭ estas pilko, ne ŝtal’ kaj vapor’, <br/>
          Ne peza maŝino, anhela kaj laca, <br/>
          Sed lada ludilo, amuza kaj paca.
        </p>
        
        
        <p class="mb-3 bold text-center">* * *</p>

        
        <p class="poem-block mb-3">
          De kie? Ja kiel? Kaj kial la hast’? <br/>
          Do kio ĝin pelas, puŝante kun drast’, <br/>
          Ke tak-to-to takte rapidas la spir’? <br/>
          Vaporo varmega ĝin tiras al ir’. <br/>
          Vapor’ el kaldrono al piŝtoj ŝoviĝas <br/>
          Kaj piŝtoj de ambaŭ flankoj moviĝas. <br/>
          Vapor’ ilin puŝas, dum trajno surrelas, <br/>
          La trajno do iras, ĉar ili ĝin pelas. <br/>
          La radoj tondradas kaj frapas en takt’: <br/>
          Tak-to-to, tak-to-to, tak-to-to, tak-tak(t)!
        </p>
      </div>
  `
  )
}

const itemName = {
  esp: 'Julian Tuwim'
}

const item = {
  itemlink: getLink(itemName.esp),
  esp: {
    itemName: itemName.esp,
    itemContent: content.esp,
    itemTranslator: translator.esp
  }
}

export default item;